import { render, staticRenderFns } from "./NewTaskDialog.vue?vue&type=template&id=93212e2a"
import script from "./NewTaskDialog.vue?vue&type=script&lang=js"
export * from "./NewTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./NewTaskDialog.vue?vue&type=style&index=0&id=93212e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports